import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import * as actionTypes from "../../../store/actions/types";
import { connect } from "react-redux";
import { RiArrowRightLine } from "react-icons/ri";
import { GetIcon } from "../../../config/icon";
import { Button } from "../..";

const Index = (props) => {
  return (
    <>
      <div
        className={`bank-card__wrapper d-flex flex-row align-items-center ${
          props.preview ? "preview" : props.isActive ? "isActive" : ""
        } ${props.style}`}
        onClick={props.onClick}
      >
        {props.logo && (
          <div className={"bcw__logo"}>
            <img src={props.logo} alt="creditcard offers" />
          </div>
        )}
        {!props.logo && (
          <div className={"bcw__icon"}>{GetIcon(props?.iconName)}</div>
        )}
        <div
          className={"d-flex"}
          style={{ width: "100%", paddingLeft: "12px" }}
        >
          <div className={"d-flex flex-column justify-content-center"}>
            {props.preview && props.title && (
              <div className={"bcw__title"}>{props.title}</div>
            )}
            <div className={"bcw__name"}>{props.name}</div>
          </div>
        </div>
        {!props.preview && (
          <>
            {props.isEditButton === true ? (
              <>
                <div>
                  <Button
                    text={"Edit"}
                    onClick={props.onClickEdit}
                    type={"btn-edit"}
                  />
                </div>
              </>
            ) : (
              <>
                <div
                  className="bcw__action-icon d-flex flex-column justify-content-center"
                  onClick={props.onClickEdit}
                >
                  <RiArrowRightLine />
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

Index.defaultProps = {
  title: "",
};

const mapStateToProps = (state) => {
  return {
    isOpenSearchMerchant: state.merchantReducer.isOpenSearchMerchant,
    selectMerchant: state.merchantReducer.selectMerchant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClickSelectedOffer: (payload) =>
      dispatch({ type: actionTypes.SELECTED_SEARCH_MERCHANT_MODAL, payload }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
